import { createAction } from '@ngrx/store';

const PREFIX = '[Action] ';

export const doNothingAction = createAction(PREFIX + 'Do Nothing');
